import React from 'react';
import DesktopAppSection from '../public/DesktopAppSection';

const SlideSix = () => <DesktopAppSection showHeader />;

export default SlideSix;
